//Training Resource Tab constant
export const TRAINING_SYSTEM_TYPE_BUILD_IN_TRAINING = "Built-in Training";
export const TRAINING_SYSTEM_TYPE_THIRD_PARTY_TRAINING =
  "Third Party Training System";
